export default __webpack_public_path__ + "static/media/banner-reveal.eb6be4ac.png";